<p-sidebar [(visible)]="visible" class="ss-g-custom-sidebar-width ss-l-class-metaApp" position="right" [modal]="!isMobile"
    (onHide)="visibleChange.emit(false); close.emit()" [style]="{
    'display': 'flex',
    'flex-direction': 'column'
  }">

    <ng-template pTemplate="header">
        <h4 class="mb-0">Apps > TikTok</h4>
    </ng-template>

    <div style="flex:1 1 auto; overflow-y:auto" class="sidebar-content">
        <app-feed-help [text]="'TikTok'" [videoUrl]="'https://youtube.com/video-tutorial'"
            [supportUrl]="'https://meusite.com/suporte'">
        </app-feed-help>

        <ng-container *ngIf="!loading; else sidebarSkeleton">
        <!-- Contas -->
        <ng-container *ngIf="(tiktokAccounts?.length || 0) > 0">
            <div class="card shadow-none">
                <div class="text-900 text-xl font-semibold mb-4">
                    Contas <small class="text-sm">({{ tiktokAccounts.length }})</small>
                </div>

                <div *ngFor="let acct of tiktokAccounts; trackBy: trackByUid" class="card shadow-none"
                    style="position:relative;">

                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-sm p-button-primary text-sm"
                        style="position:absolute; top:-0.5rem; right:-0.5rem; width:1.75rem; height:1.75rem; border-radius:4px; z-index:10; padding:0;"
                        (click)="onRemoveTikTokAccount(acct)">
                    </button>

                    <div class="flex align-items-center justify-content-between gap-2">
                        <div class="flex align-items-center gap-2 overflow-hidden">
                            <img [src]="acct.picture || 'assets/avatar-placeholder.png'" alt="avatar"
                                class="flex-shrink-0" style="width:32px; height:32px; border-radius:12%;" />
                            <div class="overflow-hidden">
                                <div class="font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ acct.username || acct.name }}</div>
                                <div class="text-xs text-secondary-300 white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ acct.uid }}</div>
                            </div>
                        </div>
                        <i class="pi pi-check-circle text-green-600 text-lg flex-shrink-0"></i>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- CTA conectar -->
        <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none"
            style="height:160px;" (click)="onAddTikTokAccount()">
            <img src="assets/tiktok.webp" width="36" class="mb-3" />
            <span class="font-medium">Conectar conta do TikTok</span>
            <span class="text-sm text-500">Conecte uma conta do TikTok para começar</span>
        </div>
        </ng-container>

        <ng-template #sidebarSkeleton>
            <div class="card shadow-none">
                <p-skeleton width="8rem" height="1.5rem" styleClass="mb-4"></p-skeleton>
                <div class="flex align-items-center gap-2 mb-3">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <div class="flex-1">
                        <p-skeleton width="60%" height="1rem" styleClass="mb-1"></p-skeleton>
                        <p-skeleton width="40%" height="0.75rem"></p-skeleton>
                    </div>
                </div>
                <div class="flex align-items-center gap-2">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <div class="flex-1">
                        <p-skeleton width="60%" height="1rem" styleClass="mb-1"></p-skeleton>
                        <p-skeleton width="40%" height="0.75rem"></p-skeleton>
                    </div>
                </div>
            </div>
            <p-skeleton width="100%" height="160px"></p-skeleton>
        </ng-template>

    </div>

    <ng-template pTemplate="footer">
        <div style="text-align:right; padding:0 1rem 1rem;">
            <button pButton pRipple label="Fechar" class="p-button-outlined"
                (click)="visibleChange.emit(false); close.emit()"></button>
        </div>
    </ng-template>
</p-sidebar>